import { Navigate, useLocation, useParams } from '@suntex.core/nav';

/**
 * Catch-all for the dashboard's wildcard child route (e.g. legacy/short
 * player links). Redirects into the dashboard's internal hash-based routing.
 *
 * Uses relative navigation (`..`) rather than a hardcoded path so this
 * component never needs to know the dashboard's full mounted path — it
 * simply navigates to its own parent route, which can be mounted at any
 * base path in any deployment.
 *
 * This route should be placed as the last child of the dashboard route,
 * as the last sibling of the dashboard component itself.
 */
export function PlayerPathRedirect() {
  const params = useParams();
  const rest = params['*'] ?? '';
  const { search } = useLocation();

  return <Navigate to={`..${search}#/${rest}`} relative="route" replace />;
}
